import { Component } from "react";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion'

//Components
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import { TermsArray } from "./TermsArray";

class TermsAndConditions extends Component {
  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  toggleAccordion = (index) => {
    this.setState((prevState) => ({
      openIndex: prevState.openIndex === index ? null : index,
    }));
  };

  render() {
    const { t } = this.props;
    const termsData = TermsArray;

    return (
      <Auxiliary>

      {isDesktop ? (
        <div className={`x-container`}>
          <section className="tnc-section">
          <h4 className="tnc-header"><b>X33 AFFILIATE</b> {t("tnc.header")}</h4>
          <p className="tnc-desc mb-2">{t("tnc.desc-1")}</p>
          <p className="tnc-desc">{t("tnc.desc-2")}</p>
          <div className="tnc-list-container mt-4">
            <Accordion defaultActiveKey="0" alwaysOpen>
            {termsData.map((item, index) => (
              <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header>{t(item.title)}</Accordion.Header>
              <Accordion.Body>
                <ul>
                {item.sections.map((section, i) => (
                  <li key={i} className={`mb-4 ${!section.heading ? 'no-marker' : ''}`}>
                  {section.heading && <h6 className="mb-2">{t(section.heading)}</h6>}
                  {section.points && section.points.map((point, j) => (
                    <p key={j} className="mb-2">{t(point)}</p>
                  ))}
                  {section.table && Array.isArray(section.table.rows) && (
                    <div className="tnc-table-container mt-3">
                      <table className="table">
                        <thead>
                        <tr>
                          {section.table.headers.map((header, hIdx) => (
                          <th key={hIdx}>{t(header)}</th>
                          ))}
                        </tr>
                        </thead>
                        <tbody>
                        {section.table.rows.map((row, rIdx) => (
                          <tr key={rIdx}>
                          {row.map((cell, cIdx) => (
                            <td key={cIdx}>{t(cell)}</td>
                          ))}
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {section.desc && section.desc.map((desc, dIdx) => (
                    <p style={{whiteSpace: "pre-line"}} className="mb-1" key={dIdx}>{t(desc)}</p>
                  ))}
                  </li>
                ))}
                </ul>
              </Accordion.Body>
              </Accordion.Item>
            ))}
            </Accordion>
          </div>
          </section>
        </div>
      ) : (
        <>
          <section className="pf-m-dashboard">
            <MobileSubHeader
              className="bg-white"
              returnPage="/"
              header="Terms & Conditions"
              style={{ justifyContent: "unset" }}
            /> 
            <div className="mobile-container">
              <section className="tnc-section">
                <h4 className="tnc-header"><b>X33 AFFILIATE</b> {t("tnc.header")}</h4>
                <p className="tnc-desc mb-2">{t("tnc.desc-1")}</p>
                <p className="tnc-desc">{t("tnc.desc-2")}</p>
                <div className="tnc-list-container mt-4">
                  <Accordion defaultActiveKey="0" alwaysOpen>
                  {termsData.map((item, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header>{t(item.title)}</Accordion.Header>
                    <Accordion.Body>
                      <ul>
                      {item.sections.map((section, i) => (
                        <li key={i} className={`mb-4 ${!section.heading ? 'no-marker' : ''}`}>
                        {section.heading && <h6 className="mb-2">{t(section.heading)}</h6>}
                        {section.points && section.points.map((point, j) => (
                          <p key={j} className="mb-2">{t(point)}</p>
                        ))}
                        {section.table && Array.isArray(section.table.rows) && (
                          <div className="tnc-table-container mt-3">
                            <table className="table">
                              <thead>
                              <tr>
                                {section.table.headers.map((header, hIdx) => (
                                <th key={hIdx}>{t(header)}</th>
                                ))}
                              </tr>
                              </thead>
                              <tbody>
                              {section.table.rows.map((row, rIdx) => (
                                <tr key={rIdx}>
                                {row.map((cell, cIdx) => (
                                  <td key={cIdx}>{t(cell)}</td>
                                ))}
                                </tr>
                              ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                        {section.desc && section.desc.map((desc, dIdx) => (
                          <p style={{whiteSpace: "pre-line"}} className="mb-1" key={dIdx}>{t(desc)}</p>
                        ))}
                        </li>
                      ))}
                      </ul>
                    </Accordion.Body>
                    </Accordion.Item>
                  ))}
                  </Accordion>
                </div>
              </section>
            </div>
          </section>
        </>
        )}
      </Auxiliary>
    );
  }
}

export default (withNamespaces("translation")(TermsAndConditions));
